import useBeneficiariesNotifications from './useBeneficiariesNotifications';
import useFeesNotifications from './useFeesNotifications';
import useValuationsNotifications from './useValuationsNotifications';

export const useNotifications = () => {
  useBeneficiariesNotifications();
  useValuationsNotifications();
  useFeesNotifications();
};

export default useNotifications;
